import React from "react";
import "./Graphs.css";
import graphImg1 from "../../assets/Graphs/Frame 155.svg";
import arrw1 from "../../assets/Graphs/Vector 2.svg";
import graphImg2 from "../../assets/Graphs/Frame 156.svg";
import graphbarImg from "../../assets/Graphs/Group 151.svg";
const Graphs = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const graphs = document.querySelectorAll(".graph_div");
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            entry.target.style.animationDelay = `${index * 0.3}s`; // Add delay for sequential animation
            entry.target.classList.add("animate"); // Add the animation class
            observer.unobserve(entry.target); // Stop observing once animated
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% visible
      }
    );
  
    graphs.forEach((graph) => observer.observe(graph));
  });
  
  return (
    <div className="graphs_container">
      <div className="graph_div graph_div_1">
        <div className="graph1_left_div">
          <p>Monthly Expenses</p>
          <div className="graph1_left_content">
            <img src={graphImg1} alt="graphImg1" />
            <p>₹1.2M</p>
            <div className="graph1_left_content_increase">
              <img src={arrw1} alt="arrw1" />
              <p>+14%</p>
            </div>
          </div>
        </div>
        <div className="graph1_right_div">
          <div className="graph1_right_line_div">
            <div className="graph1_right_line1_outer">
              <div className="graph1_right_line1_inner1"></div>
            </div>
            <p>1</p>
          </div>
          <div className="graph1_right_line_div">
            <div className="graph1_right_line1_outer">
              <div className="graph1_right_line1_inner2"></div>
            </div>
            <p>2</p>
          </div>
          <div className="graph1_right_line_div">
            <div className="graph1_right_line1_outer">
              <div className="graph1_right_line1_inner3"></div>
            </div>
            <p>3</p>
          </div>
          <div className="graph1_right_line_div">
            <div className="graph1_right_line1_outer">
              <div className="graph1_right_line1_inner4"></div>
            </div>
            <p>4</p>
          </div>
          <div className="graph1_right_line_div">
            <div className="graph1_right_line1_outer">
              <div className="graph1_right_line1_inner5"></div>
            </div>
            <p>5</p>
          </div>
        </div>
      </div>
      <div className="graph_div graph_div_2">
        <div className="graph2_left_div">
          <p>Monthly Revenue</p>
          <div className="graph2_left_content">
            <img src={graphImg2} alt="graphImg2" />
            <p>4.2M</p>
            <div className="graph2_left_content_increase">
              <img src={arrw1} alt="arrw1" />
              <p>+24%</p>
            </div>
          </div>
        </div>
        <div className="graph2_right_div">
          <div className="graph2_right_line_div">
            <div className="graph2_right_line_outer"></div>
            <p>jun</p>
          </div>
          <div className="graph2_right_line_div1">
            <div className="graph2_right_line_outer1"></div>
            <p>jul</p>
          </div>
          <div className="graph2_right_line_div2">
            <div className="graph2_right_line_outer2"></div>
            <p>aug</p>
          </div>
          <div className="graph2_right_line_div3">
            <div className="graph2_right_line_outer3"></div>
            <p>sep</p>
          </div>
        </div>
      </div>
      <div className="graph_div graph_div_3">
        <div className="graph3_left_div">
          <p className="graph3_left_div_ex">Monthly Expenses</p>
          <div className="graph3_left_content">
            <img src={graphImg1} alt="graphImg1" />
            <p>86%</p>
            <div className="graph3_left_content_increase">
              <img src={arrw1} alt="arrw1" />
              <p>+18%</p>
            </div>
          </div>
        </div>
        <div className="graph3_right_div">
          <img src={graphbarImg} alt="graphbarImg" />
          <div className="graph3_right_div_numbers">
            <p>1</p>
            <p>2</p>
            <p>3</p>
            <p>4</p>
            <p>5</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Graphs;
